<section class="hero is-dark is-small"><div class="hero-body"><div class="container"><h1 class="title"><span class="icon-text"><span class="icon"><i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i></span><span>Something went wrong</span></span></h1></div></div></section>
<section class="section container">
  <div class="notification is-danger is-light">
    <strong>The static SmallCats preview could not load this page.</strong>
    <p data-error-message></p>
  </div>
</section>
